var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", {
    staticStyle: {
      display: "inline-block",
      "min-width": "30px",
      "text-align": "left",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }